<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnMakeInv'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"
                    @btnMakeInv="btnMakeInv()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">                          
                          <i-label :label="'Invoice No : '" class="pl-2"/>
                          <v-col cols="2">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              maxLength="30"
                              v-model="invNo"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                           <i-label :label="'Periods : '"  class="pl-2"/>
                            <v-col cols="2">
                              <DxDateBox
                                :value="startDate"
                                height="30px"
                                display-format="yyyy-MM-dd"
                                :acceptCustomValue="false"
                                @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }"
                              />
                            </v-col>
                            <span class="pa-1 subTitle"> ~ </span>
                            <v-col cols="2">
                              <DxDateBox
                                :value="endDate"
                                height="30px"
                                display-format="yyyy-MM-dd"
                                :acceptCustomValue="false"
                                @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }"
                              />
                            </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                  
                  <DxDataGrid id="departmentInformation" 
                    class="listBox" 
                    :ref="hycot101Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"                    
                    @cellPrepared="cellPrepared"
                  >                                        
                    <DxColumn caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" cell-template="rowNo"/>
                        <template #rowNo="{ data }">
                            <div>{{ data.component.pageIndex() * data.component.pageSize() + data.rowIndex + 1 }}</div>
                        </template>
                    <DxColumn caption="Invoice No" width="30%" data-type="string" alignment="left"  :allow-editing="false" >                      
                        <DxColumn data-field="forwInvNo" caption="Invoice" width="20%" data-type="string" alignment="left"  :allow-editing="false" />
                        <DxColumn data-field="btnDel" caption="Btn Del" width="10%" data-type="string" alignment="center" cell-template="delBtn" :allow-editing="false" />
                    </DxColumn>

                     <template #delBtn="{ data: cellInfo }">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 delBtn" @click="btnDelete(cellInfo)" >
                                <v-icon small class="mt-n1">
                                    mdi-trash-can-outline
                                </v-icon>
                                Delete
                            </v-btn>                          
                         </template>
                    
                    <DxColumn caption="Total Bill No" width="20%" data-type="string" alignment="center" :allow-editing="false">
                        <DxColumn data-field="blCnt" caption="Total 1" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                        <DxColumn  caption="Total 2" width="10%" data-type="string" alignment="center" cell-template="billNoBtn" :allow-editing="false" />                        
                    </DxColumn>
                     <template #billNoBtn="{ data : cellInfo }">
                        <v-btn v-if="cellInfo.data.blCnt > 0 ? true : false" small elevation="0" color="transparent"  class="px-1 py-0 receiptBtn" @click="btnDetail1(cellInfo)" >
                            <v-icon small class="mt-n1">
                                mdi-arrow-right-box
                            </v-icon>
                            Detail B/L 
                        </v-btn>
                        <v-btn v-else small elevation="0" color="transparent" class="px-1 py-0 addBtn" @click="btnDetail1(cellInfo)" >
                            <v-icon small class="mt-n1">
                                mdi-clipboard-plus-outline
                            </v-icon>
                            Add B/L
                        </v-btn>
                     </template>

                    <DxColumn caption="Total Amount" width="50%" data-type="number" format="#,###" alignment="center" :allow-editing="false" >

                        <DxColumn data-field="amtVnd" caption="VND (Include VAT)" width="20%" data-type="number" format="#,###" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="amtUsd" caption="USD" width="20%" data-type="number" format="#,###.##" alignment="center" :allow-editing="false" />
                        <DxColumn width="10%" data-type="string" alignment="center" cell-template="amtBtn" :allow-editing="false" />

                    </DxColumn>

                      <template #amtBtn="{ data : cellInfo }">
                        <v-btn v-if="cellInfo.data.amtVnd + cellInfo.data.amtUsd > 0 ? true : false" small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="btnDetail2(cellInfo)" >
                            <v-icon small class="mt-n1">
                                mdi-arrow-right-box
                            </v-icon>
                            Detail T.Fee
                        </v-btn>
                        <v-btn v-else small elevation="0" color="transparent" class="px-1 py-0 addBtn" @click="btnDetail2(cellInfo)" >
                            <v-icon small class="mt-n1">
                                mdi-clipboard-plus-outline
                            </v-icon>
                            Add Fee
                        </v-btn>
                     </template>
                                      
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import dayjs from 'dayjs';
import { hycot101, deleteInvoice, makeInvoice } from '@/api/view/hycot/1/hycot101.js'

export default {
  name: 'hycot101',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxButton,
    DxExport,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,      

      hycot101Ref: 'hycot101Ref',
      gridMainList: [{a: '2022/12/05', id: 1 , test: "N"}],

      invNo: '',     
      showReceive: true,
      startDate: '',
      endDate: '',
      stDte: '',
      edDte: '',
     
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.hycot101Ref)
    },
  },
  mounted() {   

    var date = new Date();
    this.startDate = new Date(date.getFullYear() - 1, date.getMonth(), 1)
    this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.getStrFormat(this.startDate)
    this.getEndFormat(this.endDate)
    
    this.doSearchMain()
  },
  methods: {   
     getStrFormat(date) {
      this.stDte =  dayjs(date).format('YYYYMMDD')
      return dayjs(date).format('YYYYMMDD')
    },
    getEndFormat(date) {
      this.edDte = dayjs(date).format('YYYYMMDD')
      return dayjs(date).format('YYYYMMDD')
    },
    btnRetrieve(){
      if(this.invNo === null){
        this.invNo = ''
      }
      this.doSearchMain()
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
          makerCd: this.$store.state.user.makerCd ,
          invNo: !this.invNo ? '' : this.invNo,
          stDte: this.stDte,
          edDte: this.edDte    
      }

      console.log('the param :', params)
      await hycot101(params).then(res => {
        res.list.forEach(e => {
          e.id = e.rnum
        });
        this.gridMainList = res.list
      }).finally(() => {
        console.log('the list :', this.gridMainList)
        this.endLoading()
      })

    },
    cellPrepared(e) {
      if (e.rowType === 'header') {
       
         if (e.column.caption === 'Invoice' && e.columnIndex == 0) {
              e.cellElement.setAttribute('colspan', 2)
            } else if (e.column.caption === 'Btn Del' &&  e.columnIndex == 1) {
              e.cellElement.style.display = 'none'
            }
         if (e.column.caption === 'Invoice No' && e.columnIndex == 1) {
           e.cellElement.setAttribute('rowspan', 2)
        } else if (e.column.caption === 'Invoice' && e.columnIndex == 0) {
           e.cellElement.style.display = 'none'
        }

        if (e.column.caption === 'Total 1' && e.columnIndex == 2) {
          e.cellElement.setAttribute('colspan', 2)
        } else if (e.column.caption === 'Total 2' && e.columnIndex == 3) {
          e.cellElement.style.display = 'none'
        }
        if (e.column.caption === 'Total Bill No' && e.columnIndex == 3) {
          e.cellElement.setAttribute('rowspan', 2)
        } else if (e.column.caption === 'Total 1' && e.columnIndex == 2) {
          e.cellElement.style.display = 'none'
        }
      }

      if (e.rowType === 'data') {
          if (e.data.blCnt > 0) {
                if(e.column.name === 'forwInvNo') {
                    e.cellElement.setAttribute('colspan', 2)
                } else if (e.column.name === 'btnDel') {
                    e.cellElement.style.display = 'none'
                }        
          }      
      }
    },
      
    btnDetail1(e) {       
        this.$router.push({ name: 'hycot102', params: { invNo: e.data.forwInvNo, div: 1 } });
    },

    btnDetail2(e) {
      this.$router.push({ name: 'hycot102', params: { invNo: e.data.forwInvNo, div: 2 } });
    },
      
    btnDelete(e) {
      let invoice = e.data.forwInvNo     

       this.vToastifyPrompt(
        this.$t('Do you want to delete this invoice?'),
        'info',
         current => {   

          this.openLoading('searching')
          
          const param = {
            makerCd: this.$store.state.user.makerCd,
            invNo: invoice
          }
          deleteInvoice(param)
            .then(res => {
                
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              this.btnRetrieve()
              this.endLoading()
            })
        },
        null,
        false
      )

    },
    btnMakeInv() {
      

      if (!this.invNo) {
        this.vToastify(this.$t("Please input Invoice no!"), 'warn')
        return
      }

       this.vToastifyPrompt(
        this.$t('Do you want to make new Invoice [' + this.invNo + ']?'),
        'info',
        current => {

          this.openLoading('searching')

          const param = {
            makerCd: this.$store.state.user.makerCd,
            invNo: this.invNo
          }
          makeInvoice(param)
            .then(res => {
              console.log(res)
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              this.invNo = ''
              this.btnRetrieve()
              this.endLoading()
            })
        },
        null,
        false
      )                  
      
    }
  }
}
</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
    color: #4980BC;
  }
  .receiptBtn:hover {
    color: blue;
  }

  .addBtn {
    font-weight: bold;
    color: #FF3333;
  }
  .addBtn:hover {
    color: #CC0000;
  }

  .delBtn {
    font-weight: bold;
    color: #FF66B2;
  }
  .delBtn:hover {
    color: #CC0066;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>